/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon24Regular = forwardRef('ArrowDCornerRightUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M22.369 9.131a.875.875 0 1 1-1.238 1.238l-5.256-5.257V17A3.875 3.875 0 0 1 12 20.875H3a.875.875 0 1 1 0-1.75h9A2.125 2.125 0 0 0 14.125 17V5.112L8.869 10.37A.875.875 0 1 1 7.63 9.13l5.504-5.504a2.637 2.637 0 0 1 3.73 0l5.504 5.504Z" })));
});
